(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["corporate-projects"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-corporate-projects]').forEach((section) => {
  if (section.dataset.initialized) return;
  section.dataset.initialized = 'true';

  const data = JSON.parse(section.querySelector('[data-projects-json]').textContent);
  const dialog = section.querySelector('.corporate-projects__dialog');
  const image = section.querySelector('.corporate-projects__viewer-image');
  const dots = section.querySelector('.corporate-projects__dots');
  const previous = section.querySelector('.corporate-projects__previous');
  const next = section.querySelector('.corporate-projects__next');
  const close = section.querySelector('.corporate-projects__close');

  const fields = {
    category: section.querySelector('.corporate-projects__viewer-category'),
    client: section.querySelector('.corporate-projects__viewer-client'),
    product: section.querySelector('.corporate-projects__viewer-product'),
    scent: section.querySelector('.corporate-projects__detail-scent'),
    scentValue: section.querySelector('.corporate-projects__detail-scent dd'),
    customisation: section.querySelector('.corporate-projects__detail-customisation'),
    customisationValue: section.querySelector('.corporate-projects__detail-customisation dd'),
    description: section.querySelector('.corporate-projects__viewer-description')
  };

  let projectIndex = 0;
  let imageIndex = 0;

  const project = () => data[projectIndex];

  function renderImage() {
    const images = project().images;
    const current = images[imageIndex];

    image.src = current ? current.src : '';
    image.alt = current ? current.alt : '';
    previous.hidden = images.length < 2;
    next.hidden = images.length < 2;

    dots.replaceChildren(...images.map((item, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = `corporate-projects__dot ${index === imageIndex ? 'is-active' : ''}`;
      dot.setAttribute('aria-label', `View image ${index + 1}`);
      dot.setAttribute('aria-pressed', index === imageIndex ? 'true' : 'false');
      dot.addEventListener('click', () => {
        imageIndex = index;
        renderImage();
      });
      return dot;
    }));
  }

  function renderProject() {
    const current = project();

    fields.category.textContent = current.category || '';
    fields.client.textContent = current.client || '';
    fields.product.textContent = current.product || '';
    fields.scent.hidden = !current.scent;
    fields.scentValue.textContent = current.scent || '';
    fields.customisation.hidden = !current.customisation;
    fields.customisationValue.textContent = current.customisation || '';
    fields.description.innerHTML = current.description || '';

    renderImage();
  }

  section.querySelectorAll('[data-project-index]').forEach((button) => {
    button.addEventListener('click', () => {
      projectIndex = Number(button.dataset.projectIndex);
      imageIndex = 0;
      renderProject();
      dialog.showModal();
      close.focus();
    });
  });

  section.querySelectorAll('[data-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.filter;

      section.querySelectorAll('.corporate-projects__filter').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active);
      });

      section.querySelectorAll('.corporate-projects__card').forEach((card) => {
        card.hidden = filter !== 'all' && card.dataset.category !== filter;
      });
    });
  });

  previous.addEventListener('click', () => {
    imageIndex = (imageIndex - 1 + project().images.length) % project().images.length;
    renderImage();
  });

  next.addEventListener('click', () => {
    imageIndex = (imageIndex + 1) % project().images.length;
    renderImage();
  });

  close.addEventListener('click', () => dialog.close());

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });

  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft' && !previous.hidden) previous.click();
    if (event.key === 'ArrowRight' && !next.hidden) next.click();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
